// !!!: ???: keys as french words/phrases ??
export default Object.freeze({
  general: {
    upload_error: "Upload error",
    upload_error_pdf: "Upload error PDF",
    files_must_be_pdfs: "Some files were not accepted. They must be pdfs.",
    app_slogan: "plateforme de gestion des votes en assemblées générales",
    Forgot_password: "Forgot your password?",
    Password: "Password",
    ProfileInfo: "Informations sur le profil",
    Phone: "Téléphone",
    Logout: "Se déconnecter",
    Username: `Nom d'utilisateur`,
    "N°_de_votant": "N° de votant",
    Numéros_de_lots: "Numéro(s) de lot(s)",
    New_lot: "Nouveau lot",
    droit_de_votes: "Droit de votes",
    Notification: "Notification",
    Informations: "Informations",
    Subdélégation: "Subdélégation",
    Adresse: "Adresse",
    Civilité: "Civility",
    Nom: "First name",
    Prénom: "Last name",
    Email: "Email",
    No_de_rue: "Street number",
    Rue: "Rue",
    Complément: "Complément",
    Code_postal: "Code postal",
    Ville: "Ville",
    Pays: "Pays",
    Type_d_envoi_prefere: "Type d’envoi préféré",
    Lre_agreement: "Agreement LRE",
    Lre_agreement_media: "Agreement file LRE",
    Copropriété: "Coownership",
    Indiquer_la_mention_légale: "Indicate the legal notice",
    Statut: "Status",
    Majorité: "Majority",
    Pouvoirs: "Powers",
    Copropriétaires: "Co-owners",
    Import: "Import",
    Export: "Export",
    Mentions: "Mentions",
    Tous: "All",
    Yes: "Yes",
    No: "No",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    Browse: "Browse",
    majority_name: "Majority name",
    loadmore: "loadmore",
    create: "Add",
    edit: "Edit",
    duplicate: "Duplicate",
    delete: "Delete",
    reset_sort: "reset sort",
    cancel: "Cancel",
    continue: "Continue",
    enregistrer: "Save",
    enregistrer_and_continue: "Save and continue",
    newtag: "New tag",
    newresolution: "New resolution",
    etiquettes: "Tags",
    tags: "Tags",
    list_de_resolution: "Resolution list",
    filter: "Filter",
    settings: "Settings",
    reset: "Reset",
    Send_notifications: "Send notifications",
    Are_you_sure: "Are you sure?",
    Voting_Category_Name: "Voting Category Name",
    Name: "Name",
    Building: "Building",
    Posibility_revoter_different_majoity: "Possibility to vote again by a different majority",
    Meeting: "Meeting",
    Meetings: "Meetings",
    Choose_a_file_or_drop_it_here: "Choose a file or drop it here...",
    Drop_file_here: "Drop file here...",
    New_Copropriétaire: "New Co-owner",
    Mention_à_faire_apparaître_sur_le_procèsverbal: "Mention to appear on the minutes",
    no_charges_generales: "No general charges",
    set_charges_generales_now: "Do you want to define them now?",
    accepte_resolution_must: "To be accepted, the resolution must have:",
    general_charges: "General charges",
  },

  //@ Table
  // Catalogs
  // Catalogs Resolutions
  dt_catalog_name_key: "Name",
  dt_catalog_nr_resolution_key: "Number of resolutions",
  dt_catalog_tags_key: "Labels",
  dt_catalog_filter_tags_key: "Labels",
  dt_resolution_name_key: "Name",
  dt_resolution_description_key: "Description",
  dt_resolution_filter_name_key: "Name",
  dt_resolution_filter_description_key: "Description",
  // Catalogs des Immeubles
  dt_building_name_key: "Name",
  dt_building_address_key: "Address",
  dt_building_coownership_key: "Coownership",
  dt_building_with_majority_key: "With Majority",
  dt_building_filter_name_key: "Name",
  dt_building_filter_address_key: "Address",
  dt_building_filter_coownership_key: "Coownership",
  dt_building_filter_with_majority_key: "With Majority",

  // Catalogues des Majorites
  dt_majority_name_key: "Name",
  dt_majority_contitions_key: "Info",
  dt_majority_filter_name_key: "Name",

  //Convocations
  convocation_choose_notification_type: "Choose convocation notification type",
  convocation_send_manually: "Manually",
  convocation_send_cogeprint: "CogePrint",
  //Meetings
  dt_meetings_building_key: "Building",
  dt_meetings_name_key: "Meeting name", // Meeting name
  dt_meetings_date_key: "Date",
  dt_meetings_access_key: `Access modalities`,
  dt_meetings_nr_resolutions_key: "Number of resolutions",
  dt_meetings_filter_building_key: "Building",
  dt_meetings_filter_name_key: "Meeting name",
  dt_meetings_filter_date_key: "Date",
  dt_meetings_filter_access_key: "Access modalities",
  //
  dt_voting_name_key: "Summoned",
  dt_voting_representant_key: "Representant",
  dt_voting_for_key: "For",
  dt_voting_abstain_key: "Abstain",
  dt_voting_against_key: "Against",
  dt_voting_filter_name_key: "Summoned",
  dt_voting_filter_representant_key: "Representant",
  dt_voting_filter_vote_key: "Vote",

  //
  dt_meeting_resolutions_name_key: "Name",
  dt_meeting_resolutions_description_key: "Description",
  dt_meeting_resolutions_voting_rights_key: "Catégorie de vote",
  dt_meeting_resolutions_majority_key: "Majority",
  dt_meeting_resolutions_filter_name_key: "Name",
  dt_meeting_resolutions_filter_description_key: "Description",
  dt_meeting_resolutions_filter_voting_right_key: "Catégorie de vote",
  dt_meeting_resolutions_filter_majority_key: "Majority",
  dt_mandate_filter_name_key: "Name",

  //
  dt_mandate_number_key: "Nr vote",
  dt_mandate_name_key: "Nom",
  dt_mandate_representant_key: "Representative",
  dt_mandate_logs_key: "Logs",

  //Voting Categories
  dt_voting_cat_name_key: "Name",
  dt_voting_cat_building_key: "Building",
  dt_voting_cat_filter_name_key: "Name",
  dt_voting_cat_filter_building_key: "Building",
  dt_is_charge_generale_key: "Is charge générale",
  dt_is_charge_generale_filter_key: "Is charge générale",
  // Coproprietaire
  dt_building_owner_nr_votant_key: "Nr votant",
  dt_building_owner_name_key: "Nom",
  dt_building_owner_email_key: "Email",
  dt_building_owner_filter_nr_votant_key: "Nr votant",
  dt_building_owner_filter_name_key: "Name",
  dt_building_owner_filter_email_key: "Email",
  dt_building_owner_tantiemes_key: "Tantièmes",
  dt_building_owner_delete_all: "Delete all building owners",
  //

  header: {
    my_account: "My account",
    home: "Home",
    catalogs: "Catalogs",
    meetings: "Meetings",
    tableau_au_bord: "Dashboard",
    configurations: "Configurations",
  },

  catalogs: {
    home: "Home",
    catalog_name: "Catalog name",
    catalogs: "Catalogs",
    resolutions: "Resolutions",
    buildings: "Buildings",
    majorities: "Majorities",
    resolutions_catalogs: "Catalogs of Resolutions",
    resolutions_create: "Add a Catalog of Resolutions",
    resolutions_edit: "Edit a Catalog of Resolutions",
    buildings_catalogs: "Catalogs of Buildings",
    buildings_create: "Add a Catalog of Buildings",
    buildings_asl_create: "Add an ASL",
    buildings_edit: "Edit a Catalog of Buildings",
    majorities_catalogs: "Catalogs of Majorities",
    majorities_create: "Add a Catalog of Majorities",
    majorities_edit: "Edit a Catalog of Majorities",
    // ???: keys as french words/phrases ??
    Le_nom_du_copropriété: "Name of the co-ownership",
    Ladresse_du_copropriété: "The address of the co-ownership",
    Statut_de_copropriété: "Co-ownership status",
    Limmeuble_est_soumis_à_un_plafond_de_majorité: "The building is subject to a majority limit",
    Copropriété: "Co-ownership",
    article22: "Activate article 22",
    Définir_le_plafond_de_majorité: "Define the majority limit",
    Les_pouvoirs_sont_conditionnés: "Powers are conditioned",
    Pouvoirs_par_mandataire: "Powers by proxy",
    Possibilité_de_combiner_les_deux: "Possibility of combining the two",
    Tantièmes_détenus: "Tiers inmates",
    Mandataire_inclus: "Representative included",
    Par_exemple_3_pouvoirs_par_mandataire_OU_10_de_tantièmes_détenus: `For example 3 powers per representative OR 10% of directors' fees.`,
    Nom_de_la_majorité: "Name of majority",
    un_total_de_tantièmes: "a total of bonuses", //@ POINTS OR POWERS HERE
    un_nombre_de_votants: "a number of voters",
    "défavorables_/_contre": "against / for",
    qui_doit_être: "that must be",
    des_tantièmes_ou_des_votants: "directors' fees or voters",
    selon_le_1er_choix: "according to the 1st choice",
    avec_cumul_des_mandats: "with multiple mandates",
    sans_cumul_des_mandats: "without multiple mandates",
    Ainsi_1_votant_avec_2_mandats_compte_pour_3_votants:
      "Thus, 1 voter with 2 mandates counts as 3 voters (case of co-ownership)",
    Ainsi_1_votant_avec_2_mandats_compte_pour_1_votant:
      "Thus, 1 voter with 2 mandates counts as 1 voter",
    Possibilité_de_revote_à_une_majorité_différente:
      "Possibility of voting by a different majority",
  },

  meetings: {
    edit_meeting: "Edit Meeting",
    another_in_progress: "There is another meeting in progress",
    meeting: {},

    meeting_agenda: {},

    meeting_presence: {},

    votingTable: {
      name: "Name",
      representant: "Representant",
      for: "For",
      abs: "Abs.",
      against: "Against",
      vote: "Vote",
    },

    meeting_start: {},
    meeting_create: "New meeting",
    presence_count: "Attendance rate:",
    present: "Presents",
    representatives: "Representatives",
    total_present: "Total present or representatives",
    absent: "Absent and not represented",
    total: "Total",
  },

  resolutions: {
    no: "Resolution n°",
    libelle_resolution: "Wording of the resolution",
    majority: "Majority",
    details_resolution: "Resolution details",
    files: "Fichiers",
    without_vote: "Without Vote",
  },

  buildings: {
    building_created: "Building created",
    building_created_successfully: "Building created successfully",
  },

  category: {
    create_categoty: "Ajouter une nouvelle catégorie",
  },

  footer: {
    message: "Voting software for general meetings",
  },

  voting_categories: {
    title: "Voting Categories",
  },

  configuration_settings: {
    title: "Settings",
    titleLegalMentions: "Legal mentions",
    titlePdfSettings: "Configure PDF",
    titleAgencyLRESettings: "Agency LRE",
    createLegalMentions: "Create legal mentions",
    createPdfSettings: "Create pdf configuration",
    create_settings: "Create new settings",
  },

  duplicate_meeting: {
    warning_message:
      "In the process of duplication we seen that there are some files from the resolution attachments that are missing form the server. We have duplicate the meeting but without the resolution attachments.",
  },
});
